import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card p-5" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  key: 0,
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_xlsx_export_modal"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_14 = { class: "fw-bolder me-5" }
const _hoisted_15 = { class: "me-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-customer-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "me-2",
      "data-kt-customer-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode("Selected ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-customer-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_18 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "fa fs-2x fa-check text-secondary"
}
const _hoisted_21 = {
  key: 1,
  class: "fa fs-2x fa-times text-danger"
}
const _hoisted_22 = {
  href: "#",
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_23 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_24 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-175px py-4",
  "data-kt-menu": "true"
}
const _hoisted_25 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_26 = { class: "menu-item px-3" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "menu-item px-3"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 3,
  class: "menu-item px-3"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 4,
  class: "menu-item px-3"
}
const _hoisted_36 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ExportXlsxModal = _resolveComponent("ExportXlsxModal")!
  const _component_ExportCustomerCsvModal = _resolveComponent("ExportCustomerCsvModal")!
  const _component_ExportCustomerCsvModalTest = _resolveComponent("ExportCustomerCsvModalTest")!
  const _component_ResetPasswordModal = _resolveComponent("ResetPasswordModal")!
  const _component_EditAccountSettingModal = _resolveComponent("EditAccountSettingModal")!
  const _component_EditCompanySettingModal = _resolveComponent("EditCompanySettingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, {
                src: "/media/icons/duotune/general/gen021.svg",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control w-250px ps-15",
              placeholder: _ctx.translate('SEARCH_USERS')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.checkedCustomers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.type !== 'inactive')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_inline_svg, {
                          src: "/media/icons/duotune/arrows/arr078.svg",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('EXPORT_RESPONSE_SUMMARY_BUTTON_LABEL')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.type === 'inactive')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light-primary me-3",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportAccounts('not_approved')))
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_inline_svg, {
                          src: "/media/icons/duotune/arrows/arr078.svg",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('EXPORT_ACCOUNTS_BUTTON_LABEL')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-light-primary me-3",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportAccounts('approved')))
                    }, [
                      _createElementVNode("span", _hoisted_12, [
                        _createVNode(_component_inline_svg, {
                          src: "/media/icons/duotune/arrows/arr078.svg",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('EXPORT_ACCOUNTS_BUTTON_LABEL')), 1)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.checkedCustomers.length), 1),
                  _createTextVNode("Selected ")
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteFewCustomers()))
                }, " Delete Selected ")
              ])),
          _hoisted_16
        ])
      ]),
      (_ctx.tableData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": true,
              loading: _ctx.tableLoading
            }, {
              "cell-checkbox": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: customer,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkedCustomers) = $event))
                  }, null, 8, _hoisted_19), [
                    [_vModelCheckbox, _ctx.checkedCustomers]
                  ])
                ])
              ]),
              "cell-id": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.id), 1)
              ]),
              "cell-azienda_id": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.azienda_id), 1)
              ]),
              "cell-denom": _withCtx(({ row: user }) => [
                _createVNode(_component_router_link, {
                  to: `/admin/${user.id}/dashboard`,
                  onClick: ($event: any) => (_ctx.userNavigate(user)),
                  class: "menu-link px-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(user.denom), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"])
              ]),
              "cell-settore": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(_ctx.translateKey(
              _ctx.settoriList[
                user.yearlyParameters[0].settore.id
              ].descrizione
            )), 1)
              ]),
              "cell-p_iva": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.p_iva), 1)
              ]),
              "cell-azienda_creation_timestamp": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(_ctx.dateFormatter(new Date(user.azienda_creation_timestamp * 1000))), 1)
              ]),
              "cell-user_name": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.user_name), 1)
              ]),
              "cell-email": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.email), 1)
              ]),
              "cell-user_active": _withCtx(() => [
                (_ctx.type == 'active')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                  : (_openBlock(), _createElementBlock("i", _hoisted_21))
              ]),
              "cell-actions": _withCtx(({ row: user }) => [
                _createElementVNode("a", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.translate("ADMIN_PANEL_ACTIONS_DROPDOWN_LABEL")) + " ", 1),
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_inline_svg, {
                      src: "/media/icons/duotune/arrows/arr072.svg",
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.type == 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: `/admin/${user.id}/dashboard`,
                          onClick: ($event: any) => (_ctx.userNavigate(user)),
                          class: "menu-link px-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("VIEW_LABEL_ADMIN_PANEL")), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    (_ctx.type == 'active')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "menu-link px-3",
                          onClick: ($event: any) => (_ctx.deactivateUser(user.azienda_id))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.translate("INACTIVE_LABEL")), 1)
                        ], 8, _hoisted_27))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "menu-link px-3",
                          onClick: ($event: any) => (_ctx.activateUser(user.azienda_id))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.translate("ACTIVE_LABEL")), 1)
                        ], 8, _hoisted_28))
                  ]),
                  (_ctx.type !== 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "menu-link px-3",
                          onClick: ($event: any) => (_ctx.refuseUser(user.azienda_id))
                        }, _toDisplayString(_ctx.translate("REFUSE_LABEL")), 9, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'inactive')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "menu-link px-3",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#edit_account_setting_modal",
                          onClick: ($event: any) => (_ctx.selectCustomer(user))
                        }, _toDisplayString(_ctx.translate("HEADER_EDIT_ACCOUNT_SETTINGS_BUTTON")), 9, _hoisted_32)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'inactive')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "menu-link px-3",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#edit_company_setting_modal",
                          onClick: ($event: any) => (_ctx.selectCustomer(user))
                        }, _toDisplayString(_ctx.translate("HEADER_EDIT_AZIENDA_SETTINGS_BUTTON")), 9, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'inactive')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "menu-link px-3",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#reset_password_modal",
                          onClick: ($event: any) => (_ctx.selectCustomer(user))
                        }, _toDisplayString(_ctx.translate("passwordReset")), 9, _hoisted_36)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ExportXlsxModal, { data: _ctx.tableData }, null, 8, ["data"]),
    (_ctx.type === 'inactive')
      ? (_openBlock(), _createBlock(_component_ExportCustomerCsvModal, {
          key: 0,
          data: _ctx.tableData
        }, null, 8, ["data"]))
      : (_openBlock(), _createBlock(_component_ExportCustomerCsvModalTest, {
          key: 1,
          data: _ctx.tableData
        }, null, 8, ["data"])),
    _createVNode(_component_ResetPasswordModal, { customer: _ctx.selectedCustomer }, null, 8, ["customer"]),
    _createVNode(_component_EditAccountSettingModal, { customer: _ctx.selectedCustomer }, null, 8, ["customer"]),
    _createVNode(_component_EditCompanySettingModal, { customer: _ctx.selectedCustomer }, null, 8, ["customer"])
  ], 64))
}